import { format } from "./format";
import { availableLayouts } from "./layouts";
import { interceptElementById } from "./dom";

const nepalify = {
  format: format,
  availableLayouts: availableLayouts,
  interceptElementById: interceptElementById,
};

export default nepalify;
